import { Controller } from '@hotwired/stimulus'
import { i18n } from '../lib/i18n'

/**
 * Async Loader Controller
 * Loads content asynchronously into a target element
 */
export default class extends Controller {
  static values = {
    url: String,
    target: String
  }

  load() {
    const targetElement = document.getElementById(this.targetValue)
    if (!targetElement) {
      console.error(`Target element #${this.targetValue} not found`)
      return
    }

    // Show loading state
    targetElement.innerHTML = `
      <div class="flex items-center justify-center py-8">
        <span class="loading loading-spinner loading-md mr-2"></span>
        <span class="text-gray-500">${i18n.t('async_loader.loading_data')}</span>
      </div>
    `

    // Disable button during load
    this.element.disabled = true
    const originalContent = this.element.innerHTML
    this.element.innerHTML = `
      <span class="loading loading-spinner loading-xs mr-1"></span>
      ${i18n.t('async_loader.loading')}
    `

    fetch(this.urlValue, {
      method: 'GET',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok')
        return response.text()
      })
      .then(html => {
        targetElement.innerHTML = html
      })
      .catch(error => {
        targetElement.innerHTML = `
          <div class="alert alert-error">
            <span>${i18n.t('async_loader.failed_to_load', { error: error.message })}</span>
          </div>
        `
      })
      .finally(() => {
        this.element.disabled = false
        this.element.innerHTML = originalContent
      })
  }
}
